import React from 'react';
import { Typography, Box, Button, Chip, Card } from 'components';
import format from 'date-fns/format';

const CareerDevCard = ({ careerDevPost }) => {
  const {
    trainingType,
    company,
    city,
    location,
    description,
    startDate,
    endDate,
    role,
    skills = [],
    cost,
    url,
    email,
    timeCommitmentAmount,
    timeCommitmentPeriod,
    timeCommitmentHours,
    timeCommitmentFrequency,
  } = careerDevPost;

  const formatDate = (date) => {
    try {
      return format(date instanceof Date ? date : date.toDate(), 'MMM d, yyyy');
    } catch (e) {
      return '';
    }
  };

  const getLocationText = (locationType) => {
    switch (locationType) {
      case 'in-person':
        return 'In person only';
      case 'remote':
        return 'Virtual / Remote';
      case 'hybrid':
        return 'Hybrid In-person / Remote';
      default:
        return locationType;
    }
  };

  return (
    <Card className="job-card">
      <Box p={2}>
        <Typography variant="h5" style={{ fontWeight: '500' }}>
          {trainingType}
        </Typography>
        <Typography variant="body1" style={{ marginBottom: 8 }}>
          {company}
        </Typography>

        <Box display="flex" flexDirection="row" mb={1}>
          <Typography variant="body2" style={{ marginRight: 8 }}>
            <strong>Location:</strong> {city}
          </Typography>
          <Typography variant="body2">
            <strong>Format:</strong> {getLocationText(location)}
          </Typography>
        </Box>

        <Typography variant="body2" style={{ marginBottom: 8 }}>
          <strong>Time Commitment:</strong> {timeCommitmentAmount} {timeCommitmentPeriod}, {timeCommitmentHours} hours per {timeCommitmentFrequency}
        </Typography>

        <Typography variant="body2" style={{ marginBottom: 8 }}>
          <strong>Dates:</strong> {formatDate(startDate)} - {formatDate(endDate)}
        </Typography>

        {role && (
          <Typography variant="body2" style={{ marginBottom: 8 }}>
            <strong>Role:</strong> {role}
          </Typography>
        )}

        <Box mb={2}>
          {skills.map((skill, index) => (
            <Chip 
              key={`${skill}-${index}`} 
              label={skill} 
              size="small" 
              style={{ margin: '0 4px 4px 0' }} 
            />
          ))}
        </Box>

        <Typography variant="body2" style={{ marginBottom: 8 }}>
          {description}
        </Typography>

        {cost && (
          <Typography variant="body2" style={{ marginBottom: 8 }}>
            <strong>Cost:</strong> {cost}
          </Typography>
        )}

        <Box mt={2}>
          {url && (
            <Button
              variant="outlined"
              color="primary"
              href={url.startsWith('http') ? url : `http://${url}`}
              target="_blank"
              rel="noopener noreferrer"
              fullWidth
              style={{ marginBottom: 8 }}
            >
              More Info
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            href={`mailto:${email}`}
            fullWidth
          >
            Contact
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default CareerDevCard;
